import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const fileUrlQueryAtom = createMutationAtomFactory(
  'customerPortal.fileUrl',
  (params: { fileIds: string[] }) => ({
    filesGenerateFileAccessURL: {
      __args: {
        fileIds: params.fileIds,
      },
      results: {
        fileId: true,
        url: true,
      },
    },
  }),
  {
    select: ({ filesGenerateFileAccessURL }) =>
      filesGenerateFileAccessURL.results ?? [],
  },
);
